import React from 'react';
import { styled } from '@mui/system';
import Tooltip from '@mui/material/Tooltip';
import measurementsIcon from '#component/icon/measurements';
import { isUndefinedOrNull, momentFormat } from '#helper';

const Container = styled('div')(() => ({
  minWidth: 24,
  whiteSpace: 'nowrap',
  '& svg': {
    verticalAlign: 'middle'
  },
  display: 'flex',
  alignItems: 'center'
}));

const NotAvailable = styled('span')(() => ({
  marginLeft: 2,
  opacity: 0.5
}));

function DashboardCharge(props) {
  const {
    account,
    device,
    battery
  } = props;

  const tooltip = !isUndefinedOrNull(battery.value) ?
    `${battery.description}. ${momentFormat(battery.timestamp, account, 'dateTimePartial')}` :
    'No value within 7 days';

  return (
    <Tooltip title={tooltip} placement="top">
      {!isUndefinedOrNull(battery.value) ?
        <Container>
          {measurementsIcon('battery', device, battery.value)}
          {battery.label || battery.value}
          {battery.unit}
        </Container> :
        <NotAvailable>n/a</NotAvailable>}
    </Tooltip>
  );
}

export default DashboardCharge;
